import React from 'react';

import Section from '../components/Section';
import NewCarousel from '../components/NewCarousel';

const ImageCarousel = ({articleType, contentType, imagesCarousel}) => {
    return imagesCarousel.map((carousel, i) => 
        <Section
            articleType={articleType}
            textColor={contentType === 'success-story' ? 'text-light' : 'text-dark'}
            key={`image-carousel-${i}`}
        >
            <NewCarousel
                images={carousel}
                contentColor='primary'
                isMacro={true}
                id={'carousel-'+i}
            />
        </Section>
    )
}

export default ImageCarousel;
